import { FC } from 'react';
import { GalleryThumbnailProps } from './types';
import { SliderThumbnailIcon, SliderThumbnailImage } from './styles';
import Icon from 'src/units/Icon';
import { isVimeoUrl, isYoutubeUrl } from 'src/utils';

export const GalleryThumbnail: FC<GalleryThumbnailProps & { children?: any }> = ({
  item,
  active = false,
  thumbnailsGap = 0,
  onPointerUp = () => {},
}) => {
  if (
    item.endsWith('.jpg') ||
    item.endsWith('.png') ||
    item.endsWith('.gif') ||
    item.endsWith('.webp')
  ) {
    return (
      <SliderThumbnailImage
        src={item}
        active={active}
        marginRight={thumbnailsGap}
        onPointerUp={onPointerUp}
      />
    );
  }
  if (isYoutubeUrl(item) || isVimeoUrl(item) || item.endsWith('.mp4') || item.endsWith('.pdf')) {
    return (
      <SliderThumbnailIcon active={active} marginRight={thumbnailsGap} onPointerUp={onPointerUp}>
        {item.endsWith('.pdf') ? <Icon.Document /> : <Icon.Video />}
      </SliderThumbnailIcon>
    );
  }
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'gray',
      }}
    >
      <p>Unsupported content type</p>
    </div>
  );
};
